<template>
  <div class="">
    <div class="page-contain">
      <div class="page-contain-tab">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form label-position="top">
                      <el-form-item label="业务结果">
                          <el-input v-model="searchData.treatAreaResult"></el-input>
                      </el-form-item>
                      <el-row>
                          <el-col :span="5">
                              <el-form-item label="部门">
                                  <el-select @change="searchData.medicalField = '';searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.departId">
                                    <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="5">
                              <el-form-item label="Franchise/DA">
                                  <el-select @change="searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.medicalField">
                                    <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(searchData.departId, true))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="5">
                              <el-form-item label="团队">
                                  <el-select clearable placeholder="请选择" v-model="searchData.teamL4">
                                    <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(searchData.departId, searchData.medicalField, true))" :key="item.id" :value="item.id" :label="item.teamName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="9">
                              <el-form-item label="产品">
                                  <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.productId">
                                      <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                                      </el-option>
                                  </el-select>
                                  <el-button type="primary" @click="handleSearch()">搜索</el-button>
                              </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>
              </div>
          </div>
          <div class="operate">
            <div>
              <a :href="'/static/file/busTreatResult.xlsx?t='+new Date().getTime()">
                <el-button type="primary" plain>导出模板</el-button>
              </a>
              <span>
                <common-upload
                  :importApi="crudApi"
                  importType="Excel"
                  :onSuccess="handleUpdateSuccess"
                >
                  <el-button type="primary" plain>批量上传</el-button>
                </common-upload>
              </span>
              <el-button type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
              <el-button :disabled="selectedData.length <= 0" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
              <el-button type="primary" @click="handleAddNewClick()">添加业务结果</el-button>
            </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :searchDataLikeField="{'treatAreaResult':'*'}"
            :crudApi="crudApi"
            :tableData.sync="domainresultData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :afterSave="handleDomainResultChange"
            :afterDelete="handleDomainResultChange"
            :selectedDataArray.sync="selectedData"
            addSuccessMessages="添加业务结果成功"
            editSuccessMessages="编辑业务结果成功"
            deleteSuccessMessages="删除业务结果成功"
            deleteBatchSuccessMessages="批量删除业务结果成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>
              <el-table-column sortable prop="departId" label="部门">
              </el-table-column>
              <el-table-column sortable prop="medicalField" width="135">
                <template slot="header" slot-scope="scope">
                  <div style="display:inline-block">
                    <div>Franchise/DA</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="teamL4" label="团队">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="productId" label="产品">
              </el-table-column>
              <el-table-column sortable prop="treatAreaResult" label="业务结果">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="更新时间">
              </el-table-column>
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">业务结果</template>
            <template slot="editForm">
                <el-row>
                  <el-col>
                    <el-form-item required label="部门" prop="departId">
                        <el-select @change="addNewOrEditData.medicalField = '';addNewOrEditData.teamL4 = ''" placeholder="请选择" v-model="addNewOrEditData.departId">
                            <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="Franchise/DA" prop="medicalField">
                        <el-select @change="addNewOrEditData.teamL4 = ''" placeholder="请选择" v-model="addNewOrEditData.medicalField">
                            <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(addNewOrEditData.departId, false))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="团队" prop="teamL4">
                        <el-select placeholder="请选择" v-model="addNewOrEditData.teamL4">
                            <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(addNewOrEditData.departId, addNewOrEditData.medicalField, false))" :key="item.id" :value="item.id" :label="item.teamName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="产品" prop="productId">
                        <el-select filterable placeholder="请选择（可搜索）" v-model="addNewOrEditData.productId">
                            <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item required label="业务结果" prop="treatAreaResult">
                      <el-input type="textarea" v-model="addNewOrEditData.treatAreaResult" placeholder="请输入业务结果（建议20个字符以内）"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加业务结果？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存业务结果？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除业务结果？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除业务结果？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import domainresult from '@/api/bizmanagement/domainresult';
import { mapGetters, mapActions } from 'vuex';
import * as orgUtil from '@/util/organizationUtil'
import bizmanagement from '@/api/bizmanagement/index';

export default {
  data() {
    return {
      isConfigurationData:true,
      departsList :[],
      medicalFieldList :[],
      teamList :[],
      domainresultData :[],
      searchData: {
        treatAreaResult:'',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      addNewOrEditData: {
        treatAreaResult:'',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      crudApi: domainresult,
      selectedData: [],
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetNameByRowIdField','userInfo']),
  },
  methods: {
    ...mapActions(['reloadBaseDataByType','initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalField, independ) {
      return orgUtil.teamArray(departId, medicalField, independ);
    },
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave(saveData) {
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('业务结果.xlsx');
    },
    handleUpdateSuccess() {
      this.handleSearch();
    },
    handleDomainResultChange() {
      this.reloadBaseDataByType('DomainResult');
    },
    getCustomizationArray(arr){
      if(arr.length > 0){
        const customizationArray = arr.map(ele => {
          const data = {
            id: ele,
            teamName: ele,
          }
          return data
        });
        return customizationArray
      }else return []
    }
  },
  mounted() {
    bizmanagement.queryBusDataOrg().then((res) => {
      this.isConfigurationData = res.isConfigurationData
        this.departsList = this.getCustomizationArray(res.departList)
        this.medicalFieldList = this.getCustomizationArray(res.medicalFieldList)
        this.teamList = this.getCustomizationArray(res.teamList)
        this.initBaseDataByTypes(['Depart','MedicalField','Product'])
        .then(() => {
          this.handleSearch();
        })
    })
   
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 90%;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?7c80daac